import { configureStore } from "@reduxjs/toolkit";
import painEntryFormReducer from "./../slices/painEntryFormSlice";
import AuthReducer from "./../slices/authSlice";
import DashboardReducer from "./../slices/dashboardSlice";
import OrderCreamReducer from "./../slices/orderCreamSlice";
import ChatReducer from "./../slices/chatSlice";
import GeneralReducer from "./../slices/generalSlice";
import { useDispatch } from "react-redux";
export const store = configureStore({
  reducer: {
    chat: ChatReducer,
    painEntryForm: painEntryFormReducer,
    auth: AuthReducer,
    dashboard: DashboardReducer,
    orderCream: OrderCreamReducer,
    general: GeneralReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export const useAppDispatch = () => useDispatch<AppDispatch>();
